import * as React from 'react';
import {Container} from 'reactstrap';
import './App.css';
import Header from './Screen/Header';
import Profile from './Screen/Profile';
import Gallery from './Screen/Gallery';
import Place from './Screen/Place';
import Information from './Screen/Information';
import Contact from './Screen/Contact';
import KakaoShareButton from './Screen/KakaoShareButton';
import Footer from './Screen/Footer';
import CommentComponent from './Screen/Comment/CommentComponent';
import config from './config';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import disableScroll from 'disable-scroll';

import {
  SpinnerBox,
  SpinnerContainer
} from './Screen/Comment/styles';

function Spinner() {
  return (
    <React.Fragment>
      <SpinnerBox />
    </React.Fragment>
  );
}


export default function App() {
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(true);
  const [edited, setEdited] = React.useState(true);
  const [isKakaoBrower, setKakaoBrower] = React.useState(false); 
  const refImg = React.useRef(null)
  const [fullScreenMode, setFullScreenMode] = React.useState(false)
  
  function onScreenChange(props) {
    if(refImg.current != null) {
      const items = refImg.current.props.items      
      if(props){
        refImg.current.slideToIndex(0)
        items.map((item)=> {
          item.originalHeight= 1300;
          item.originalWidth= 1300;
          return item;
        })
        disableScroll.on();
        setFullScreenMode(true)
      }
      else {
        items.map(item => {
          item.originalHeight= 400;
          item.originalWidth= 400;
          return item;
        })
        disableScroll.off();
        setFullScreenMode(false)
      }
    }
  }

  React.useEffect(()=>{
    fetch(process.env.REACT_APP_DB_HOST + 'comments')
    .then(response => response.json())
    .then(json => {
      setData(json);
      setLoading(false);
      setEdited(false);
    })
  }, [edited])
  
  React.useEffect(() => { 
    const isKakao = navigator.userAgent.match("KAKAOTALK"); 
    if(isKakao) {
      setKakaoBrower(true); 
    }
  }, []);

  if(loading)
    return (
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    );
  // else if(isKakaoBrower)
  //   return (
  //     <Alert severity="warning">브라우저로 열어주세요!</Alert>
  //     );
  else
    return (
      <Container className="app">
        <Header config={config} />
        <Box sx={{ width: '100%', marginTop: 10}}>
          <Divider sx={{marginBottom: 3}}></Divider>
          <Profile config={config} />
        </Box>
        <Box sx={{ width: '100%', marginTop: 15, marginBottom: 5}}>
          <Divider sx={{marginBottom: 6}}><h3>초대합니다</h3></Divider>
          <Box sx={{ width: '100%',
                      fontSize: '1.1rem',
                      fontWeight: '300',
                      fontFamily: 'Noto Sans KR'
                      }}>
            <img className="img-fluid" 
            height='80px'
            width='80px'
            src={config.wedding.message} 
            alt={'message'}
            />
            <br></br>
            <br></br>
            <p>하늘이 열린 날</p>
            <p>두 사람이 하나가 될</p>
            <p>인생의 여정을 시작하려 합니다.</p>
            <br></br>
            <p>잡은 손을 놓지 않고, 걸음을 맞추며</p>
            <p>열심히 사랑하고, 열심히 살아가겠습니다.</p>
            <br></br>
            <p>저희의 소중한 출발을 </p>
            <p>축복하고 축하해주시길 소망합니다.</p>
            <br></br>
          </Box>
          <Box sx={{ width: '100%',
                      fontSize: '1rem',
                      fontWeight: '100',
                      fontFamily: 'Noto Sans KR'
                      }}>
            <p>규범과 규영 드림.</p>
          </Box>
        </Box>
        {/* <Box sx={{ width: '100%', marginTop: 10, marginBottom: 3}}>
          <Divider sx={{marginBottom: 3}}><h3>  연락처  </h3></Divider>
          <Contact config={config}></Contact>
        </Box> */}
        <Box className="map-button" sx={{ width: '100%', marginTop: 5, marginBottom: 5}}>
          <KakaoShareButton />
        </Box>        
        <Box sx={{ width: '100%', marginTop: 10, marginBottom: 3}}>
          <Divider sx={{marginBottom: 10}}><h3>  우리의 아름다운 시작  </h3></Divider>
          <Gallery 
              config={config} 
              refImg={refImg}
              onScreenChange={onScreenChange}
              />
        </Box>
        {/* <Box sx={{ width: '100%', marginTop: 10, marginBottom: 3}}>
          <Divider sx={{marginBottom: 10}}><h3>  오시는 길  </h3> </Divider>
          <Place config={config} fullScreenMode={fullScreenMode}/>
        </Box> */}
        <Box sx={{ width: '100%', marginTop: 5, marginBottom: 3}}>
          <Divider sx={{marginBottom: 5}}><h3>  알림  </h3> </Divider>
          <Information config={config}/>
        </Box>
        <Box sx={{ width: '100%', marginTop: 10, marginBottom: 3}}>
          <Divider sx={{marginBottom: 10}}><h3>  축하 메세지를 남겨보세요  </h3> </Divider>
          <CommentComponent comments={data.comments} setEdited={setEdited}/>
        </Box>  
        <Box sx={{ width: '100%', marginTop: 5, marginBottom: 3}}>
          <Footer></Footer>
        </Box>
      </Container>
    );
}
